<template>
  <div class="container">
    <div class="frame">
      <PlaylistFrame :playlist="$store.deviceStartData.main_play_list" :playlist-type="'main'" />
    </div>
    <div class="infoscreen-container">
      <TicketPortrait
        v-if="tempTicket"
        ref="tempTicket"
        :style="{ display: showTempTicket ? 'flex' : 'none' }"
        :ticket="tempTicket"
      />
      <div
        v-for="(item, index) in currentItems"
        :key="item ? item.id : -(index + 1)"
        class="infoscreen-item"
        :style="{backgroundColor: $store.infoscreenData.infoboardBackgroundColor}"
      >
        <TicketPortrait
          v-if="item"
          ref="ticketRef"
          :ticket="item"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TicketPortrait from '../tickets/TicketPortrait';
import TemplateMixin from '../../mixins/TemplateMixin';
import PlaylistFrame from '../PlaylistFrame';

export default {
  name: 'TemplatePortraitFrameNew',
  components: {
    TicketPortrait,
    PlaylistFrame,
  },
  mixins: [TemplateMixin],
  computed: {
    currentItems() {
      return this.getCurrentTickets(3);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  --ticket-gap: 2px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--ticket-gap);

  .frame {
    height: 607.5px;
    width: 100%;
    border-radius: 20px;
    overflow: hidden;
  }

  .infoscreen-container {
    --ticket-gap: 2px;
    display: grid;
    grid-template-rows: repeat(3, 1fr);
    gap: var(--ticket-gap);
    flex-grow: 1;

    .infoscreen-item {
      width: 100%;
      padding: 0 5.5vw;
      border-radius: 20px;
      overflow: hidden;
    }
  }
}

</style>
